<template>
  <div>
    <div>
    <v-row>
 
      <v-col>
        <v-card style="margin-top: 100px">
        <v-card
          class="mx-auto rounded-xl"
          max-width="100%"
          :elevation="10" 
        
        >
          <v-card-title>Data Visual</v-card-title>
          <iframe
            :src="embedUrl"
            width="100%"
            height="600px"
            frameborder="0"
            allowfullscreen="true"
          ></iframe>
        </v-card>
      </v-card>
      </v-col>
    </v-row>
  </div>
</div>
</template>

<script>
// @ is an alias to /src
import { ParticlesBg } from "particles-bg-vue";

import PieChart from '@/components/PieChart'

import getLocalStorage from '@/services/getLocalStorage'
const localStorageData = new getLocalStorage();

//////////////services//////////////////
import pubServices from '@/services/publicServices'
const publicServices = new pubServices();


export default {


  beforeMount(){
    this.userData = localStorageData.user();
    this.currentUser = this.userData.name.toUpperCase();
    
  },
  data: () => ({

     colors: [
          'indigo',
          'warning',
          'pink darken-2',
          'red lighten-1',
          'deep-purple accent-4',
        ],

        slides: [
          require('@/assets/corousell/4.jpeg'), 
          require('@/assets/corousell/1.jpg'), // Update with the path to your image assets
          require('@/assets/corousell/2.jpg'), 
          require('@/assets/corousell/3.jpg'), 
        ],

        embedUrl: "https://app.powerbi.com/view?r=eyJrIjoiNWRiNjMyODgtMGY2OS00OTFiLTliNGEtYzY3MmU0M2IxZDZkIiwidCI6IjM3M2U5MGQyLWQ5YTMtNDNiNS04MzJlLWM4ZTk4NDdhNzlmOCIsImMiOjEwfQ%3D%3D"
  }),
}
</script>


